/* eslint-disable array-callback-return */
const generateDataLayer: any = (item: string) => {
    const dataLayer = (window as any).dataLayer || [];
    if (dataLayer) {
        dataLayer.push({
            event: "filter-interaction",
            filterName: item
        });
    }
    return dataLayer;
};

export const addFilterInteractionDataLayer = (filterName: string) => {
    return generateDataLayer(filterName);
};
